interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "pen-square" asset from the Figma 3-dot Edit/Delete menu. */
const FigmaEditIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.39333 6.44867L9.56 8.61533L7.02133 11.154C6.47933 11.696 5.74467 12 4.97867 12H4.342C4.158 12 4.00867 11.8507 4.00867 11.6667V11.03C4.00867 10.264 4.31333 9.52867 4.85467 8.98733L7.39333 6.44867ZM9.39333 4.44867L8.80733 5.03467L10.974 7.20133L11.498 6.67733C12.0647 6.11067 12.1733 5.18667 11.666 4.566C11.0827 3.85267 10.0287 3.81333 9.39333 4.44867ZM16 3.66667V12.3333C16 14.3547 14.3553 16 12.3333 16H3.66667C1.64467 16 0 14.3547 0 12.3333V3.66667C0 1.64533 1.64467 0 3.66667 0H12.3333C14.3553 0 16 1.64533 16 3.66667ZM14 3.66667C14 2.74733 13.252 2 12.3333 2H3.66667C2.748 2 2 2.74733 2 3.66667V12.3333C2 13.2527 2.748 14 3.66667 14H12.3333C13.252 14 14 13.2527 14 12.3333V3.66667Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaEditIcon;
